import { Navigate, Route, Routes } from "react-router-dom";

import { AppShell } from "@/components/app-shell";
import { RequireAuth } from "@/components/require-auth";
import { NotificationsProvider } from "@/lib/notifications";
import Login from "@/pages/login";
import Home from "@/pages/home";
import RequestsList from "@/pages/requests-list";
import RequestDetail from "@/pages/request-detail";
import NewRequest from "@/pages/new-request";
import EditRequest from "@/pages/edit-request";
import Notifications from "@/pages/notifications";
import BudgetPage from "@/pages/budget";
import VendorsPage from "@/pages/vendors";
import ReportsPage from "@/pages/reports";
import DepartmentsPage from "@/pages/departments";
import ComingSoon from "@/pages/coming-soon";

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />

      {/* Everything inside the shell requires a session and gets the app bar + bottom nav. */}
      <Route
        element={
          <RequireAuth>
            <NotificationsProvider>
              <AppShell />
            </NotificationsProvider>
          </RequireAuth>
        }
      >
        <Route path="/" element={<Home />} />
        <Route path="/requests" element={<RequestsList />} />
        <Route path="/requests/new" element={<NewRequest />} />
        <Route path="/requests/:id" element={<RequestDetail />} />
        <Route path="/requests/:id/edit" element={<EditRequest />} />
        <Route path="/notifications" element={<Notifications />} />
        <Route path="/budget" element={<BudgetPage />} />
        {/* Hub sections not built yet — one shared placeholder. */}
        <Route path="/purchase-orders" element={<ComingSoon />} />
        <Route path="/reports" element={<ReportsPage />} />
        <Route path="/vendors" element={<VendorsPage />} />
        <Route path="/departments" element={<DepartmentsPage />} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
